// In pages/MSEDCLDashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Space, Breadcrumb, Grid } from "antd";
import {
  FileTextOutlined,
  FilePdfOutlined,
  ExperimentOutlined,
  SafetyOutlined,
  ThunderboltOutlined,
  HomeOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

const MSEDCLDashboard = () => {
  const navigate = useNavigate();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  const documentTypes = [
    {
      key: "wcr",
      title: "Work Completion Report",
      subtitle: "WCR",
      icon: <FileTextOutlined />,
      color: "#1890ff",
      path: "/msedcl/wcr"
    },
    {
      key: "proforma",
      title: "Proforma/Commissioning Report",
      subtitle: "Billing",
      icon: <FilePdfOutlined />,
      color: "#52c41a",
      path: "/msedcl/proforma"
    },
    {
      key: "declaration",
      title: "Declaration / Undertaking",
      subtitle: "Annexure-A",
      icon: <SafetyOutlined />,
      color: "#fa8c16",
      path: "/msedcl/declaration"
    },
    {
      key: "meterTesting",
      title: "Meter Testing Letter",
      subtitle: "Testing Request",
      icon: <ExperimentOutlined />,
      color: "#722ed1",
      path: "/msedcl/meter-testing"
    },
  ];

  return (
    <div style={{ padding: isMobile ? '12px' : '24px' }}>
      {/* Header Section */}
      <div style={{ marginBottom: isMobile ? '16px' : '24px' }}>
        <Breadcrumb style={{ marginBottom: '12px' }}>
          <Breadcrumb.Item onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>MSEDCL Documents</Breadcrumb.Item>
        </Breadcrumb>
        <Space size="small">
          <ThunderboltOutlined style={{ fontSize: isMobile ? '18px' : '24px', color: '#1890ff' }} />
          <Title level={isMobile ? 5 : 4} style={{ margin: 0 }}>MSEDCL Documents Generation</Title>
        </Space>
      </div>

      {/* Document Grid */}
      <Row gutter={[isMobile ? 12 : 24, isMobile ? 12 : 24]}>
        {documentTypes.map((doc) => (
          <Col xs={12} sm={12} lg={6} key={doc.key}>
            <Card
              hoverable
              onClick={() => navigate(doc.path)}
              style={{
                borderRadius: '12px',
                textAlign: 'center',
                height: '100%',
                border: '1px solid #f0f0f0',
                transition: 'all 0.3s ease'
              }}
              bodyStyle={{ padding: isMobile ? '16px 12px' : '32px 24px' }}
            >
              <div style={{
                fontSize: isMobile ? '28px' : '40px',
                color: doc.color,
                marginBottom: isMobile ? '8px' : '16px',
                height: isMobile ? '44px' : '64px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {doc.icon}
              </div>
              <Title level={isMobile ? 5 : 5} style={{ marginBottom: '4px', fontSize: isMobile ? '13px' : undefined }}>
                {doc.title}
              </Title>
              <Text type="secondary" style={{ fontSize: isMobile ? '11px' : '12px' }}>
                {doc.subtitle}
              </Text>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default MSEDCLDashboard;
